export const AdvancedCoatingProductSpecSheet =
  "https://assets.servishero.com/Advanced_Disinfection_Product_Spec.pdf";
export const ProfessionalDisinfectionProductSpecSheet =
  "https://assets.servishero.com/Professional_Disinfection_Product_Spec.pdf";
